import Login from './screens/Login';
//import Layout from './components/Base/Layout'; //horizontal nav bar
import Main from './components/Main'; //vertical nav bar
import MainPlain from './components/MainPlain';
import HiddenAdminCustomerEmailControl from './components/HiddenAdminCustomerEmailControl';
import AgentSurveyForDemo from './components/v3/AgentSurvey/AgentSurveyForDemo';
import AgentSurvey from './screens/_v3/Surveys/AgentSurvey/AgentSurveyScreen';
import NotFound from './screens/NotFound';

import { ZacousticPermission } from './generated';

//import { checkPrivledges } from '../JavaScript/utils';

import CalibrationV3Screen from './screens/_v3/CalibrationScreenV3/CalibrationV3Screen';
import CalibrationV3AgentScreen from './screens/_v3/CalibrationScreenV3/agents/CalibrationV3AgentScreen';
import SurveysScreen from './screens/_v3/AdminScreenV3/SurveysScreen/SurveysScreen';
import TeamsScreen from './screens/_v3/AdminScreenV3/TeamsScreen/TeamsScreen';
import UsersScreen from './screens/_v3/AdminScreenV3/UsersScreen/UsersScreen';
import SurveyActivityScreen from './screens/_v3/SurveyActivity/SurveyActivityScreen';
import SystemDashboardScreen from './screens/_v3/SystemDashboardScreenV3/SystemDashboardScreen';

import QaDashboardScreen from './screens/_v3/QaDashboardScreenV3/QaDashboardScreen';
import QaAuditScreen from './screens/_v3/QaDashboardScreenV3/manager/audit/QaAuditScreen';
import QaCoachScreen from './screens/_v3/QaDashboardScreenV3/manager/coach/QaCoachScreen';

import CoachingDashboardScreen from './screens/_v3/CoachingDashboardV3/CoachingDashboardScreen';
//import UserManagement from '../JavaScript/zacoustic-pure/src/pages/dashboard/usersManagement';

import CustomerFacingSurvey from './screens/_v3/Surveys/CustomerFacingSurvey/CustomerFacingSurvey';
import ComcastLiveAgentSurveyScreen from './screens/_v3/LiveSurveys/ComcastLiveAgentSurveyScreen';

import TeamDashboardScreen from './screens/_v3/TeamDashboardScreen/TeamDashboardScreen';

const customerFacingSurveyRoute = {
    path: 'customersurvey',
    label: 'Customer Survey',
    hideInNav: true,
    component: CustomerFacingSurvey
};

const hiddenEndpointsCustomerEmailRoute = {
    path: 'adminemail',
    label: 'Admin Email',
    hideInNav: true,
    component: HiddenAdminCustomerEmailControl
};

const calibrationV3Route = {
    path: 'Jibe',
    label: 'Jibe Dashboard',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/Jibe/status') },
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'Status',
            component: CalibrationV3Screen,
        },
        {
            path: 'status/agent(/:agentId)',
            staticPath: 'status/agent',
            label: 'Agent Details',
            hideInNav: true,
            component: CalibrationV3AgentScreen,
        }
    ]
};

const SystemDashboardRoute = {
    path: 'SystemDashboard',
    label: 'System Dashboard',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/SystemDashboard/status') },
    roles: [ZacousticPermission.CalibrationDashboardManagerView],
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'Status',
            component: SystemDashboardScreen,
        }
    ]
};

const TeamDashboardRoute = {
    path: 'TeamDashboard',
    label: 'Team Dashboard',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/TeamDashboard/status') },
    roles: [ZacousticPermission.CalibrationDashboardSupervisorView],
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'Status',
            component: TeamDashboardScreen,
        }
    ]
};

const QaDashboardScreenRoute = {
    path: 'QualityAssurance',
    label: 'QA: JibeIQ',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/QualityAssurance/status') },
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'Status',
            component: QaDashboardScreen,
        },
        {
            path: 'status/audit(/:ticketId)',
            staticPath: 'status/audit',
            label: 'Audit',
            hideInNav: true,
            component: QaAuditScreen,
        },
        {
            path: 'status/coach(/:agentId)',
            staticPath: 'status/coach',
            label: 'Coach',
            hideInNav: true,
            component: QaCoachScreen
        }
    ]
};

const surveyActivityScreenRoute = {
    path: 'SurveyActivity',
    label: 'Survey Activity',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/SurveyActivity/status') },
    roles: [ZacousticPermission.CalibrationDashboardSupervisorView],
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'SurveyActivity',
            component: SurveyActivityScreen,
        }
    ]
};

const adminRoute = {
    path: 'admin',
    label: 'Admin',
    indexRoute: { onEnter: (nextState, replace) => replace('/admin/surveys') },
    roles: [ZacousticPermission.AdminReviewUsers, ZacousticPermission.AdminCreateEditUsers],
    childRoutes: [
        {
            path: 'users(/:routeUserId)',
            staticPath: 'users',
            label: 'Users',
            component: UsersScreen,
            roles: [ZacousticPermission.AdminReviewUsers, ZacousticPermission.AdminCreateEditUsers]
        },
        {
            path: 'teams(/:routeTeamId)',
            staticPath: 'teams',
            label: 'Teams',
            component: TeamsScreen,
            roles: [ZacousticPermission.AdminReviewUsers, ZacousticPermission.AdminCreateEditUsers]
        },
        {
            path: 'surveys(/:routeUserId)',
            staticPath: 'surveys',
            label: 'Surveys',
            component: SurveysScreen,
            roles: [ZacousticPermission.AdminReviewUsers, ZacousticPermission.AdminCreateEditUsers]
        },
        //{
        //    path: 'roles',
        //    label: 'Roles',
        //    staticPath: 'roles',
        //    component: RolesScreen,
        //    roles: [ZacousticPermission.AdminSeeRoles, ZacousticPermission.AdminCreateEditRoles]
        //}
    ]
};

const ComcastLiveAgentSurveyScreenoute = {
    path: 'LiveSurveys',
    label: 'Live Survey',
    hideInNav: false,
    indexRoute: { onEnter: (nextState, replace) => replace('/LiveSurveys/status') },
    //roles: [ZacousticPermission.AdminReviewUsers, ZacousticPermission.AdminCreateEditUsers],
    roles: [ZacousticPermission.CalibrationDashboardSupervisorView],
    childRoutes: [
        {
            path: 'status',
            staticPath: 'status',
            label: 'Status',
            component: ComcastLiveAgentSurveyScreen,
        }
    ]
};

const routeTree = [
    {
        path: '/',
        childRoutes: [
            {
                component: Main,
                indexRoute: {
                    onEnter: (nextState, replace) => {
                        replace('/SystemDashboard');
                    }
                },
                childRoutes: [
                    //ComcastLiveAgentSurveyScreenoute,
                    //{
                    //    path: 'AgentSurvey',
                    //    label: 'Agent Survey',
                    //    component: AgentSurvey
                    //},
                    SystemDashboardRoute,
                    TeamDashboardRoute,
                    calibrationV3Route,
                    surveyActivityScreenRoute,
                    QaDashboardScreenRoute,
                    //{
                    //    path: 'Coaching',
                    //    label: 'Coaching',
                    //    hideInNav: false,
                    //    component: CoachingDashboardScreen
                    //},
                    adminRoute,
                    //{
                    //    path: 'UserManagement',
                    //    label: 'Management',
                    //    hideInNav: false,
                    //    component: UserManagement
                    //},
                ]
            },
            {
                component: MainPlain,
                childRoutes: [
                    {
                        path: 'login(/:oLoginId)',
                        component: Login,
                        hideInNav: true,
                        childRoutes: []
                    },
                    //{
                    //    path: 'survey',
                    //    component: AgentSurveyForDemo,
                    //    hideInNav: true,
                    //    childRoutes: []
                    //},
                    {
                        hideInNav: true,
                        path: 'login/logoutmessage/:logoutMessage'
                    },
                    {
                        path: 'login/resetpassword/:temporaryLinkText',
                        hideInNav: true,
                        component: Login
                    },
                    //{
                    //    path: 'login/forgotpassword',
                    //    hideInNav: true,
                    //    component: Login
                    //},
                    customerFacingSurveyRoute,
                    hiddenEndpointsCustomerEmailRoute
                ]
            },
            { path: '*', component: NotFound }
        ]
    }
];

export { routeTree as default, calibrationV3Route };